import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import homeConfig from "src/resources/homePage.json";
import { Trans, useTranslation } from "react-i18next";
import { isArabic } from "src/utils/helpers";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
export default function HomeCarousel() {
  const { t } = useTranslation(["homePage"]);
  const navigate = useNavigate();
  function handleClickedButton(url: string) {
    if (url.includes("#")) {
      window.location.href = url;
    } else navigate(url);
  }

  return (
    <div className="home-carousel">
      <Carousel autoPlay interval={3000} infiniteLoop>
        {homeConfig.carouselItems.map((item, index) => (
          <div
            key={index}
            className="item-details d-flex flex-column justify-content-center align-items-center"
            style={{
              backgroundImage: `url(${require(`src/assets/images/slider/${item.name}`)})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              position: "relative",
            }}
          >
            <div
              className="d-flex flex-column justify-content-center align-items-center carousel-content"
              style={{ position: "relative", zIndex: 2 }}
            >
              <Trans>
                <h2 style={{ direction: isArabic() ? "rtl" : "ltr" }}>
                  {t(`homePage.carouselItems.slide${index + 1}.title`)}
                </h2>
                <p style={{ direction: isArabic() ? "rtl" : "ltr" }}>
                  {t(`homePage.carouselItems.slide${index + 1}.subTitle`)}
                </p>
              </Trans>
              <div className="buttons d-flex justify-content-center align-items-center gap-3">
                {item.buttons.map((button, btnIndex) => (
                  // <Button key={button.title} label={button.title} className={button.classNames}  />
                  <Button
                    key={btnIndex}
                    label={t(
                      `homePage.carouselItems.slide${index + 1}.buttons.button${
                        btnIndex + 1
                      }.title`
                    )}
                    className={button.classNames}
                    onClick={() => {
                      if (button.url) {
                        handleClickedButton(button.url);
                      }
                    }}
                  />
                ))}
              </div>
            </div>
          </div>
        ))}
      </Carousel>
    </div>
  );
}
